<div class="d-flex flex-column align-items-center justify-content-center w-100 gap-20">
  <div class="d-flex align-items-center w-100 gap-16" [@fadeAnimation]>
    <div class="line flex-grow-1"></div>
    <div class="muted-color fw-light fs-16" i18n="@@mentionedIn">Mentioned in:</div>
    <div class="line flex-grow-1"></div>
  </div>
  <div class="media-logos w-100" [@fadeAnimation]></div>
</div>
